<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Employee Incidents"
      text="Edit Employee Incidents"
      class="mb-0"
    > 
      <form>
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="subject"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('subject')"
                data-vv-name="subject"        
                label="Subject"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="description"
                v-validate="'required|max:2000'"
                :rows="4"
                :error-messages="errors.collect('description')"
                data-vv-name="description"        
                label="Description"
              />
            </v-col>            
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String, 
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        loading: false,
        dialog: false,
        subject: '',
        description: '',
        incidentId: null,
      }
    },
    methods: {
      toggleDialog (incident) {
        this.subject = incident.subject
        this.description = incident.description
        this.incidentId = incident.id

        this.dialog = true
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.incidents().update(this.employeeUid, this.incidentId, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          subject: this.subject,
          description: this.description,
        }
      },
    },
  }
</script>
